module.exports = __webpack_public_path__ + "img/silver-peak.767f1d83.webp";